import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { withRouter, useHistory } from "react-router-dom";
import Draggable from "react-draggable";
import { ResizableBox } from "react-resizable";
import "react-resizable/css/styles.css";
import { Button, Modal, Form } from "react-bootstrap";
import Select from "react-select"
import api from "../../service/api";
import { Helmet } from "react-helmet";
import slots from './slots.json'
import LoadingOverlay from "react-loading-overlay";
import { renderToStaticMarkup } from "react-dom/server";
import { buildTabloidHTML } from './buildTabloidHTML';


const TabloidEditor = (props) => {
    const history = useHistory();
    const [activeLoader, setActiveLoader] = useState(false);
    const [textLoader, setTextLoader] = useState("Gerando...");
    const [showXlsxModal, setShowXlsxModal] = useState(false);
    const [xlsxFile, setXlsxFile] = useState(null);
    const [loadingXlsx, setLoadingXlsx] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProducts, setSelectedProducts] = useState([]);
    const [placed, setPlaced] = useState([]);
    const [activeProduct, setActiveProduct] = useState(null);
    const [projecName, setProjectName] = useState("")
    const [imgSize, setImgSize] = useState(null);
    const [cover, setCover] = useState([])
    const [background, setBackground] = useState([])
    const [selectedBackground, setSelectedBackground] = useState()
    const [selectedCover, setSelectedCover] = useState(null)
    const [coverBackground, setCoverBackground] = useState(null);
    const [validate, setValidade] = useState("")
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [showCoverText, setShowCoverText] = useState(false);
    const tabloidRef = useRef(null);
    const [exportMode, setExportMode] = useState(false);
    const [pendingXlsxPages, setPendingXlsxPages] = useState([])
    const [noInterest, setNoInterest] = useState(false)
    const [noDownPayment, setNoDownPayment] = useState(false)
    const [onTicket, setOnTicket] = useState(false)
    const [onCard, setOnCard] = useState(false)
    const [coverBox, setCoverBox] = useState({
        x: 0,
        y: 0,
        width: 600,
        height: "auto",
    });
    const [nameBox, setNameBox] = useState({
        x: 0,
        y: 0,
        height: "auto",
    });
    const [pages, setPages] = useState([
        {
            id: 0,
            isCover: true,
            layout: "",
            placed: [],
            background: ""
        }
    ]);
    const [activePage, setActivePage] = useState(0);
    const [selectedLayout, setSelectedLayout] = useState(pages[0].layout);
    const [coverText, setCoverText] = useState("")
    const [coverFontSize, setCoverFontSize] = useState(48);
    const [coverFontColor, setCoverFontColor] = useState("#ffff");
    const [isOpeningProject, setIsOpeningProject] = useState(false);
    const page = pages[activePage];
    const location = useLocation();
    const DEFAULT_IMAGE_SIZE = {
        w: 200,
        h: 250,
    };
    const project = location.state?.project;
    console.log(project?.data.id)
    function normalizeProjectToEditor(project) {
        const projectData = project.data;

        return {
            id: projectData.id,
            name: projectData.name,
            validate: projectData.validate,
            coverText: projectData.coverText,
            coverTextPosition: coverBox,
            coverTemplate: projectData.coverTemplate,
            backgroundImage: projectData.backgroundImage,
            coverFontColor: projectData.coverTextColor,
            coverTextPositionX: projectData.coverTextPositionX,
            coverTextPositionY: projectData.coverTextPositionY,

            pages: (projectData.pages ?? [])
                .sort((a, b) => a.pageOrder - b.pageOrder)
                .map(page => ({
                    id: page.id,
                    layout: page.layout,

                    backgroundId: page.background?.id ?? null,
                    background: page.background ?? null,

                    slots: page.slots ?? [],

                    placed: (page.products ?? []).map(prod => ({
                        key: prod.key,
                        id: prod.id,
                        slotId: prod.slotId,

                        value: prod.productId,
                        code: prod.productCode,
                        name: prod.productName,
                        carac_1: prod.carac1,
                        carac_2: prod.carac2,
                        carac_3: prod.carac3,
                        carac_4: prod.carac4,
                        price: prod.price,

                        parcelas: prod.parcelas,
                        installments: prod.installments,
                        installmentValue: prod.installmentValue,

                        imageX: prod.imageX,
                        imageY: prod.imageY,
                        imageW: prod.imageW ?? DEFAULT_IMAGE_SIZE.w,
                        imageH: prod.imageH ?? DEFAULT_IMAGE_SIZE.h,

                        nameX: prod.nameX,
                        nameY: prod.nameY,
                        caracX: prod.caracX,
                        caracY: prod.caracY,

                        priceX: prod.priceX,
                        priceY: prod.priceY,

                        parcelasX: prod.parcelasX,
                        parcelasY: prod.parcelasY,

                        installmentsX: prod.installmentsX,
                        installmentsY: prod.installmentsY,

                        totalTermX: prod.totalTermX,
                        totalTermY: prod.totalTermY,
                        totalAPrazo: prod.totalAPrazo,

                        noInterest: prod.noInterest,
                        noDownPayment: prod.noDownPayment,
                        onCard: prod.onCard,
                        onTicket: prod.onTicket,
                        highlightedPlots: prod.highlightedPlots,

                        videoLink: prod.videoLink,
                        fontProductName: prod.fontProductName,
                        fontProductCarac: prod.fontProductCarac,
                        fontProductPrice: prod.fontProductPrice,
                        fontProductInstallmentsText: prod.fontProductInstallmentsText,
                        fontProductInstallments: prod.fontProductInstallments,
                        fontProductTotalTerm: prod.fontProductTotalTerm,
                        clickVideo: prod.clickVideo,
                        fontPaymentTags: prod.fontPaymentTags
                    }))
                }))
        };
    }

    useEffect(() => {
        if (!project) return;

        setIsOpeningProject(true);
        const normalized = normalizeProjectToEditor(project);
        setProjectName(normalized.name);
        setPages(normalized.pages);
        setSelectedBackground(normalized.backgroundImage);
        setValidade(normalized.validate);
        setSelectedCover(normalized.coverTemplate);
        setCoverText(normalized.coverText)
        setCoverFontColor(normalized.coverFontColor)
        setCoverBox({
            x: normalized.coverTextPositionX,
            y: normalized.coverTextPositionY,
            width: normalized.coverTextWidth ?? 600,
            height: normalized.coverTextHeight ?? "auto",
        })

        // Use > 0 em vez de >= 0
        if (normalized.pages && normalized.pages.length > 0) {
            const firstPage = normalized.pages[0];

            setSelectedLayout(firstPage.layout);
            setPlaced([...firstPage.placed]);
            setActivePage(0);
            // LOG CORRETO: Logue a variável local, não o estado
            // console.log('Placed definido:', firstPage.placed);
        }

        setTimeout(() => {
            setIsOpeningProject(false);
        }, 100);
    }, [project]);
    useEffect(() => {
        async function loadInitialData() {
            try {
                const [productsRes, coversRes, backgroundsRes] = await Promise.all([
                    api.get("/product"),
                    api.get("/cover/list"),
                    api.get("/background/list"),
                ]);

                const productsToSelect = productsRes.data.data.map(product => ({
                    value: product.id,
                    label: product.name,
                    price: product.price,
                    code: product.code,
                    name: product.name_advertising,
                    carac_1: product.carac_1,
                    carac_2: product.carac_2,
                    carac_3: product.carac_3,
                    carac_4: product.carac_4,
                    videoLink: product.link,
                }));

                setProducts([
                    { value: "", label: "Selecione um produto" },
                    ...productsToSelect,
                ]);

                setCover(coversRes.data.data);
                setBackground(backgroundsRes.data.data);
            } catch (error) {
                console.error("Erro ao carregar dados:", error);
                alert("Erro de conexão com o servidor.");
            }
        }

        loadInitialData();
    }, []);

    useEffect(() => {
        if (isOpeningProject) return;
        const currentPage = pages[activePage];
        if (!currentPage) return;

        setPlaced(currentPage.placed);
        setSelectedLayout(currentPage.layout);
        setActiveProduct(null);
    }, [activePage, isOpeningProject]);

    useEffect(() => {
        // 1. Se estiver abrindo o projeto, não faz nada.
        // 2. Se o 'placed' estiver vazio, não sincroniza (evita apagar os dados carregados).
        if (isOpeningProject || !placed || placed.length === 0) return;

        setPages(prev => {
            if (prev.length === 0) return prev;

            const pageToUpdate = prev[activePage];

            // Só atualiza se o que está no estado 'placed' for diferente do que já está na página
            if (pageToUpdate && JSON.stringify(pageToUpdate.placed) !== JSON.stringify(placed)) {
                return prev.map((p, i) =>
                    i === activePage ? { ...p, placed: placed } : p
                );
            }
            return prev;
        });
    }, [placed, activePage, isOpeningProject]);

    useEffect(() => {
        if (!selectedBackground) return;

        const loadBackground = async () => {
            const bg = await showBackground(selectedBackground);

            setPages(prev =>
                prev.map((p, i) =>
                    i === activePage
                        ? { ...p, background: bg }
                        : p
                )
            );
        };

        loadBackground();
    }, [selectedBackground, activePage]);

    useEffect(() => {
        if (!selectedCover || activePage !== 0) return;

        const loadCoverBackground = async () => {
            const bg = await showCover(selectedCover);
            setCoverBackground(bg);
        };

        loadCoverBackground();
    }, [selectedCover, activePage]);


    const updateCurrentPage = (newPlaced, newLayout) => {
        setPages(prevPages =>
            prevPages.map((p, index) =>
                index === activePage
                    ? { ...p, placed: newPlaced || p.placed, layout: selectedLayout || p.layout }
                    : p
            )
        );
    };
    const handleDrop = (e, data, product) => {
        setPlaced((prev) => {
            const updatedPlaced = prev.map((p) =>
                p.id === product.id ? { ...p, x: data.x, y: data.y } : p
            );
            // 💡 Salva a nova lista de produtos colocados de volta no array 'pages'
            updateCurrentPage(updatedPlaced);
            return updatedPlaced;
        });
    };
    const handleRemove = (product) => {
        setPlaced((prev) => {
            const updatedPlaced = prev.filter(
                (p) => p.value !== product.value
            );

            // 💡 Atualiza a página atual sem esse produto
            updateCurrentPage(updatedPlaced);

            return updatedPlaced;
        });
    };
    const handleAdd = (product) => {
        const selectSlots = slots[selectedLayout];
        // console.log(selectSlots)
        if (!selectSlots || selectSlots.length === 0) {
            alert("Layout inválido ou sem slots definidos.");
            return;
        }
        setPlaced(prev => {
            // 1. Encontra primeiro slot que não está sendo usado
            const usedSlotIds = new Set(prev.map(p => p.slotId));
            const slot = selectSlots.find(s => !usedSlotIds.has(s.id));
            if (!slot) {
                console.warn("Todos os slots do layout atual estão ocupados.");
                return prev;
            }

            const fontProductName = fontSizeProductName()
            const fontProductCarac = fontSizeProductCarac()
            const fontProductPrice = fontSizeProductPrice()
            const fontProductInstallmentsText = fontSizeInstallmentText()
            const fontProductInstallments = fontSizeInstallment()
            const fontProductTotalTerm = fontSizeTotalTerm()
            const fontPaymentTags = fontSizePaymentTags()
            const clickVideo = clickVideoSize()
            const newPlaced = [
                ...prev,
                {
                    key: product.value + '_' + Date.now() + Math.random(),
                    ...product,
                    slotId: slot.id,
                    imageX: slot.imageX,
                    imageY: slot.imageY,
                    imageW: slot.imageW,
                    imageH: slot.imageH,
                    nameX: slot.nameX,
                    nameY: slot.nameY,
                    caracX: slot.caracX,
                    caracY: slot.caracY,
                    priceX: slot.priceX,
                    priceY: slot.priceY,
                    parcelasX: slot.nameX,
                    parcelasY: slot.parcelasY,
                    installmentsX: slot.installmentsX,
                    installmentsY: slot.installmentsY,
                    totalTermX: slot.totalTermX,
                    totalTermY: slot.totalTermY,

                    fontProductName,
                    fontProductCarac,
                    fontProductPrice,
                    fontProductInstallmentsText,
                    fontProductInstallments,
                    fontProductTotalTerm,
                    clickVideo,
                    fontPaymentTags,

                    parcelas: 1,
                    installments: "1x R$ 0,00",
                    installmentValue: "R$ 0,00",
                    noInterst: noInterest,
                    noDownPayment: noDownPayment,
                    onCard: onCard,
                    onTicket: onTicket,
                    highlightedPlots: false
                }
            ];
            // Você deve garantir que updateCurrentPage existe e persiste a mudança no array 'pages'
            updateCurrentPage(newPlaced);
            return newPlaced;
        });
    };
    const handleDrag = (index, field, data) => {
        setPlaced(prev => {
            const updated = [...prev];
            const x = Math.round(data.x);
            const y = Math.round(data.y);
            updated[index] = {
                ...updated[index],
                [`${field}X`]: x,
                [`${field}Y`]: y
            };
            updateCurrentPage(updated)
            return updated;
        });
    };
    const handleSave = () => {
        setActiveLoader(true)
        try {
            const projectId = project?.data?.id
            api.post("/reduced-tabloid/save", {
                validate: validate,
                slots: selectedLayout,
                name: projecName,
                pages: pages,
                coverTemplate: selectedCover,
                coverText: coverText,
                coverTextPosition: coverBox,
                coverFontSize: coverFontSize,
                coverFontColor: coverFontColor,
                backgroundImage: selectedBackground,
                coverTextPositionX: coverBox.x,
                coverTextPositionY: coverBox.y,
                projectId: projectId ?? null
            })
            alert("Tabloide salvo com sucesso!");
        } catch (error) {
            console.error("Erro ao salvar:", error);
            alert("Erro ao salvar o tabloide. Entre em contato com o Suporte.");
        } finally {
            setActiveLoader(false)
        }

    };

    const handleGenerate = () => {
        setActiveLoader(true)
        api.post("/reduced-tabloid/generate", {
            validate: validate,
            slots: selectedLayout,
            name: projecName,
            pages: pages,
            coverTemplate: selectedCover,
            coverText: coverText,
            coverTextPosition: coverBox,
            coverFontSize: coverFontSize,
            coverFontColor: coverFontColor,
            backgroundImage: selectedBackground
        }, {
            responseType: 'blob'
        })
            .then((res) => {
                setActiveLoader(false)
                const url = window.URL.createObjectURL(new Blob([res.data]));
                const a = document.createElement("a");
                a.href = url;
                a.download = "tabloide.pdf";
                a.click();
            })
            .catch((err) => console.error(err));
    };

    // console.log(coverBox)
    function handleSelectChange(selectedOptions) {
        setSelectedProducts(selectedOptions || []);
    }

    function handleAddSelected() {
        if (selectedProducts.length > 0) {
            selectedProducts.forEach(product => {
                handleAdd(product); // agora já vem com preço, parcelas etc
            });
        }

        if (pendingXlsxPages.length > 0) {
            addNewPage();

            const next = pendingXlsxPages[0];
            setProducts(next);
            setSelectedProducts(next);
            setPendingXlsxPages(prev => prev.slice(1));
        }
    }

    function formatCurrencyAndInstallments(value, parcelas = 12) {
        value = value.replace(/\D/g, "");
        if (!value) {
            return {
                formatado: "R$ 0,00",
                valorNumero: 0,
                parcelas,
                valorParcela: "R$ 0,00",
                textoParcelas: `${parcelas}x R$ 0,00`
            };
        }
        const number = parseFloat(value) / 100;
        const formatado = number.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
        const valorParcelaNumber = number / parcelas;
        const valorParcela = valorParcelaNumber.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL"
        });
        return {
            formatado,
            valorNumero: number,
            parcelas,
            valorParcela,
            textoParcelas: `${parcelas}x de ${valorParcela}`
        };
    }

    function formatDate(dateString) {
        if (!dateString) return "";
        const [year, month, day] = dateString.split("-");
        return `${day}/${month}/${year}`;
    }

    const width = 1080;
    const height = 1920;

    const gridStep = 10; // distância entre as linhas (pode mudar)

    const horizontalLines = [];
    const verticalLines = [];

    for (let y = 0; y <= height; y += gridStep) {
        horizontalLines.push(
            <div
                key={`h-${y}`}
                style={{
                    position: "absolute",
                    top: `${y}px`,
                    left: 0,
                    width: "100%",
                    height: "1px",
                    background: "rgba(255,255,255,0.3)",
                    pointerEvents: "none" // não atrapalha o drag
                }}
            />
        );
    }

    for (let x = 0; x <= width; x += gridStep) {
        verticalLines.push(
            <div
                key={`v-${x}`}
                style={{
                    position: "absolute",
                    top: 0,
                    left: `${x}px`,
                    width: "1px",
                    height: "100%",
                    background: "rgba(255,255,255,0.3)",
                    pointerEvents: "none"
                }}
            />
        );
    }

    const toggleFlag = (field) => {
        setActiveProduct(prev => {
            const newActiveProduct = {
                ...prev,
                [field]: !prev[field]
            };

            setPlaced(prevPlaced => {
                const updatedPlaced = prevPlaced.map(item =>
                    item.value === newActiveProduct.value
                        ? { ...item, [field]: !item[field] }
                        : item
                );
                // 💡 Salva a nova lista de produtos colocados de volta no array 'pages'
                updateCurrentPage(updatedPlaced);
                return updatedPlaced;
            });

            return newActiveProduct;
        });
    };

    const handleLayoutChange = (newLayoutName) => {
        // 1. Atualiza o estado de controle local
        setSelectedLayout(newLayoutName);
        // console.log(newLayoutName)
        // 2. Atualiza o estado global 'pages' (Este é o passo CRÍTICO)
        setPages(prevPages =>
            prevPages.map((p, index) => {
                if (index === activePage) {
                    return {
                        ...p,
                        layout: newLayoutName,
                    };
                }
                return p;
            })
        );
    };

    function goToPage(index) {
        setPages(prev =>
            prev.map((p, i) =>
                i === activePage
                    ? { ...p, placed }
                    : p
            )
        );

        setActivePage(index);

        setPlaced(pages[index]?.placed || []);
    }

    const addNewPage = async () => {
        const bg = await showBackground(selectedBackground);

        setPages(prev => [
            ...prev,
            {
                id: prev.length + 1,
                layout: selectedLayout,
                placed: [],
                background: bg
            }
        ]);

        setActivePage(prev => prev + 1);
        setPlaced([]);
    };

    const syncPlacedToActivePage = (placedAtual) => {
        setPages(prev =>
            prev.map((p, i) =>
                i === activePage
                    ? { ...p, placed: placedAtual }
                    : p
            )
        );
    };

    const handleCoverChange = (e) => {
        const coverId = e.target.value;
        setSelectedCover(coverId);

        const coverData = cover.find(c => c.id === Number(coverId));
        if (coverData) {
            setCoverBackground(coverData.image); // URL da capa
        }
    };

    const handleBackgroundChange = (e) => {
        setSelectedBackground(e.target.value);
    };

    const showBackground = async (selectedBackground) => {
        try {
            const response = await api.get(`/background/${selectedBackground}`, {
                responseType: "blob",
            });

            const imageUrl = URL.createObjectURL(response.data);
            return imageUrl; // 👈 AGORA RETORNA A IMAGEM
        } catch (error) {
            console.log(error);
            return null;
        }
    };
    const showCover = async (selectedBackground) => {
        try {
            const response = await api.get(`/cover/${selectedBackground}`, {
                responseType: "blob",
            });

            const imageUrl = URL.createObjectURL(response.data);
            return imageUrl; // 👈 AGORA RETORNA A IMAGEM
        } catch (error) {
            console.log(error);
            return null;
        }
    };
    function formatCurrency(value) {
        value = value.replace(/\D/g, "");
        if (!value) return "R$ 0,00";
        const number = parseFloat(value) / 100;
        return number.toLocaleString("pt-BR", {
            style: "currency",
            currency: "BRL",
        });
    }

    function currencyToNumber(value) {
        if (!value) return 0;
        return parseFloat(
            value
                .replace(/\./g, "")
                .replace(",", ".")
                .replace("R$", "")
                .trim()
        ) || 0;
    }

    const fontSizeInstallment = () => {
        if (selectedLayout === 'layout 20 Produtos') return "40px";
        if (selectedLayout === 'layout 4 Produtos') return "69px";
        if (selectedLayout === 'layout 6 Produtos') return "60px";
        if (selectedLayout === 'layout 8 Produtos') return "60px";
        if (selectedLayout === 'layout 12 Produtos') return "60px";
        if (selectedLayout === 'layout 1 Produto') return "120px";
        if (selectedLayout === 'layout 2 Produtos') return "80px";
        return "40px"; // padrão
    };

    const fontSizeProductName = () => {
        if (selectedLayout === 'layout 20 Produtos') return "13px";
        if (selectedLayout === 'layout 4 Produtos') return "29px";
        if (selectedLayout === 'layout 6 Produtos') return "20px";
        if (selectedLayout === 'layout 8 Produtos') return "20px";
        if (selectedLayout === 'layout 12 Produtos') return "20px";
        if (selectedLayout === 'layout 1 Produto') return "70px";
        if (selectedLayout === 'layout 2 Produtos') return "70px";
        return "13px"; // padrão
    };
    const fontSizeProductCarac = () => {
        if (selectedLayout === 'layout 20 Produtos') return "7px";
        if (selectedLayout === 'layout 4 Produtos') return "12px"
        if (selectedLayout === 'layout 6 Produtos') return "12px"
        if (selectedLayout === 'layout 8 Produtos') return "12px";
        if (selectedLayout === 'layout 12 Produtos') return "12px";
        if (selectedLayout === 'layout 1 Produto') return "20px";
        if (selectedLayout === 'layout 2 Produtos') return "20px";
        return "7px"; // padrão
    };
    const fontSizeProductPrice = () => {
        if (selectedLayout === 'layout 20 Produtos') return "25px";
        if (selectedLayout === 'layout 4 Produtos') return "61px";
        if (selectedLayout === 'layout 6 Produtos') return "60px"
        if (selectedLayout === 'layout 8 Produtos') return "60px";
        if (selectedLayout === 'layout 12 Produtos') return "60px";
        if (selectedLayout === 'layout 1 Produto') return "155px";
        if (selectedLayout === 'layout 2 Produtos') return "90px";
        return "25px"; // padrão
    };
    const fontSizeInstallmentText = () => {
        if (selectedLayout === 'layout 20 Produtos') return "9px";
        if (selectedLayout === 'layout 4 Produtos') return "12px"
        if (selectedLayout === 'layout 6 Produtos') return "12px"
        if (selectedLayout === 'layout 8 Produtos') return "12px"
        if (selectedLayout === 'layout 12 Produtos') return "12px"
        if (selectedLayout === 'layout 1 Produto') return "33px";
        if (selectedLayout === 'layout 2 Produtos') return "20px";
        return "9px"; // padrão
    };
    const fontSizeTotalTerm = () => {
        if (selectedLayout === 'layout 20 Produtos') return "9px";
        if (selectedLayout === 'layout 4 Produtos') return "12px"
        if (selectedLayout === 'layout 6 Produtos') return "12px"
        if (selectedLayout === 'layout 8 Produtos') return "12px"
        if (selectedLayout === 'layout 12 Produtos') return "12px"
        if (selectedLayout === 'layout 1 Produto') return "33px";
        if (selectedLayout === 'layout 2 Produtos') return "20px";
        return "9px"; // padrão
    };
    const clickVideoSize = () => {
        if (selectedLayout === 'layout 20 Produtos') return "60px";
        if (selectedLayout === 'layout 4 Produtos') return "90px"
        if (selectedLayout === 'layout 6 Produtos') return "90px"
        if (selectedLayout === 'layout 8 Produtos') return "90px"
        if (selectedLayout === 'layout 12 Produtos') return "90px"
        if (selectedLayout === 'layout 1 Produto') return "150px";
        if (selectedLayout === 'layout 2 Produtos') return "90px";
    };

    const fontSizePaymentTags = () => {
        if (selectedLayout === 'layout 20 Produtos') return "9px";
        if (selectedLayout === 'layout 4 Produtos') return "12px"
        if (selectedLayout === 'layout 6 Produtos') return "12px"
        if (selectedLayout === 'layout 8 Produtos') return "12px"
        if (selectedLayout === 'layout 12 Produtos') return "12px"
        if (selectedLayout === 'layout 1 Produto') return "20px";
        if (selectedLayout === 'layout 2 Produtos') return "20px";
        return "9px"; // padrão
    }

    const getImageSize = (imgW, imgH, boxW, boxH) => {
        const scale = Math.min(boxW / imgW, boxH / imgH);

        return {
            width: imgW * scale,
            height: imgH * scale,
        };
    };

    const moveWholeProduct = (index, dx, dy) => {
        setPlaced(prev =>
            prev.map((item, i) => {
                if (i !== index) return item;

                return {
                    ...item,

                    imageX: item.imageX + dx,
                    imageY: item.imageY + dy,

                    nameX: item.nameX + dx,
                    nameY: item.nameY + dy,

                    caracX: item.caracX + dx,
                    caracY: item.caracY + dy,

                    priceX: item.priceX + dx,
                    priceY: item.priceY + dy,

                    parcelasX: item.parcelasX + dx,
                    parcelasY: item.parcelasY + dy,

                    installmentsX: item.installmentsX + dx,
                    installmentsY: item.installmentsY + dy,

                    totalTermX: item.totalTermX + dx,
                    totalTermY: item.totalTermY + dy,
                };
            })
        );
    };
    const isGroupDrag = (e) => e.shiftKey || e.ctrlKey;
    const isCover = activePage === 0;
    const handleCoverTextChange = (e) => {
        setShowCoverText(true);
        setCoverText(e.target.value);
    };

    const layoutSlots = slots[selectedLayout] || [];
    const maxPerPage = layoutSlots.length;

    const chunkArray = (array, size) => {
        const chunks = [];
        for (let i = 0; i < array.length; i += size) {
            chunks.push(array.slice(i, i + size));
        }
        return chunks;
    };

    const handleUploadXlsx = async () => {
        if (!xlsxFile) return;
        if (!selectedLayout) {
            alert("Selecione um layout antes");
            return;
        }
        const layoutSlots = slots?.[selectedLayout];
        try {
            setLoadingXlsx(true);

            const formData = new FormData();
            formData.append("file", xlsxFile);

            const response = await api.post(
                "/reduced-tabloid/create-xlsx",
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            const rawOptions = response.data.data.map((item, index) => ({
                value: item.value,
                label: item.label,
                name: item.name,
                code: item.code,
                price: item.price,
                parcelas: item.installments,
                installmentValue: item.installmentValue,
                installments: item.installments,
                noInterest: noInterest,
                noDownPayment: noDownPayment,
                onCard: onCard,
                onTicket: onTicket,
                key: `${item.code}-${index}`,
                carac_1: item.carac_1,
                carac_2: item.carac_2,
                carac_3: item.carac_3,
                carac_4: item.carac_4,
                videoLink: item.videoLink
            }));

            if (!layoutSlots || !Array.isArray(layoutSlots)) {
                alert("Layout ainda não está disponível");
                return;
            }
            // 🔥 capacidade do layout
            const maxPerPage = layoutSlots.length;

            // console.log("selectedLayout:", selectedLayout);
            // console.log("slots:", slots);
            // console.log("slots[selectedLayout]:", slots[selectedLayout]);
            // 🔥 quebra por páginas
            const pagesProducts = chunkArray(rawOptions, maxPerPage);

            // 👉 primeira página vai para o Select
            setProducts(pagesProducts[0]);
            setSelectedProducts(pagesProducts[0]);

            // 👉 guarda o excedente para as próximas páginas
            setPendingXlsxPages(pagesProducts.slice(1));

            setShowXlsxModal(false);
            setXlsxFile(null);
        } catch (err) {
            console.error(err);
            alert("Erro ao importar XLSX", err);
        } finally {
            setLoadingXlsx(false);
        }
    };

    function applyFlagToAllPages(flag, value) {
        setPages(prevPages =>
            prevPages.map(page => ({
                ...page,
                placed: page.placed.map(product => ({
                    ...product,
                    [flag]: value
                }))
            }))
        );
    }


    const handleGeneratePupper = async () => {
        try {
            setActiveLoader(true)
            const productPages = pages.filter(page => !page.isCover && page.placed && page.placed.length > 0);

            // 2. Pegamos os produtos que pertencem à capa
            const coverProducts = pages.find(p => p.isCover)?.placed || [];

            const coverPage = {
                id:0,
                isCover: true,
                background: selectedCover,
                // placed: coverProducts,
                coverText: coverText,
                coverTextPosition: coverBox,
                coverFontSize: coverFontSize,
                coverFontColor: coverFontColor, // Passando a cor
                validate: validate
            };

            // 3. Montamos o array final: Capa + Páginas de Produtos
            const finalPages = [coverPage, ...productPages].map(p => ({
                ...p,
                validate: validate
            }));
            // console.log(finalPages)
            const html = buildTabloidHTML(finalPages);
            const response = await api.post(
                "/reduced-tabloid/generate-pupper",
                {
                    html,
                    backgroundId: selectedBackground,
                    coverId: selectedCover
                },
                { responseType: "blob" } // Essencial para o Axios tratar o binário
            );

            // O response.data já deve vir como Blob por causa do responseType
            const blob = response.data;

            // Verifica se o retorno é realmente um PDF (segurança básica)
            if (blob.type !== "application/pdf") {
                console.error("O servidor não retornou um PDF válido.");
                return;
            }
            setActiveLoader(false)
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement("a");
            a.style.display = "none";
            a.href = url;
            a.download = "tabloide.pdf";

            document.body.appendChild(a); // Recomendado para alguns navegadores
            a.click();

            // Pequeno delay antes de remover e revogar para garantir o disparo do download
            setTimeout(() => {
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
            }, 100);

        } catch (error) {
            console.error("Erro ao gerar ou baixar o PDF:", error);
            // Dica: se o erro vier do Axios com responseType blob, 
            // o erro.response.data também será um blob, precisa ler com FileReader
        }
    };

    const handlePreviewPage = async () => {
        setActiveLoader(true);
        try {
            // 1. Identifica a página ativa (index que está na tela)
            // Se você não tiver currentPageIndex, substitua pelo estado que controla a página atual
            const currentPage = pages[activePage];

            let pageToPreview;

            if (activePage === 0) {
                // Monta o objeto da capa
                pageToPreview = {
                    ...currentPage,          // mantém id/layout se precisar
                    isCover: true,           // garante que renderCover será chamado
                    background: selectedCover,
                    placed: currentPage.placed || [],
                    coverText: coverText,
                    coverTextPosition: coverBox,
                    coverFontSize: coverFontSize,
                    coverFontColor: coverFontColor,
                    validate: validate
                };
            } else {
                pageToPreview = {
                    ...currentPage,
                    validate: validate
                };
            }

            // 2. Gera o HTML de APENAS UMA página
            const html = buildTabloidHTML([pageToPreview]);
            // 3. Requisição para o Puppeteer
            const response = await api.post(
                "/reduced-tabloid/generate-pupper",
                {
                    html,
                    backgroundId: selectedBackground,
                    coverId: selectedCover
                },
                { responseType: "blob" } // Mantém o binário
            );
            // 4. CRIAÇÃO DO BLOB E ABERTURA DA ABA
            // Forçamos o type para application/pdf para o navegador não baixar
            const file = new Blob([response.data], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);

            // Abre em nova aba
            const pdfWindow = window.open();
            if (pdfWindow) {
                pdfWindow.location.href = fileURL;
            } else {
                alert("O bloqueador de pop-ups impediu a abertura do preview.");
            }

        } catch (error) {
            console.error("Erro ao gerar preview:", error);
            alert("Erro ao gerar o preview da página.");
        } finally {
            setActiveLoader(false);
        }
    };

    // console.log("Renderizando agora - Itens no placed:", placed.length);
    return (
        <LoadingOverlay active={activeLoader} spinner text={textLoader}>
            <><Helmet>
                <link
                    href="https://fonts.googleapis.com/css2?family=Helvetica:wght@100;300;400;700&display=swap"
                    rel="stylesheet"
                />
            </Helmet>
                <div className="container-fluid mt-12" style={{
                    zoom: 1,
                    transform: "none",
                    fontFamily: "Helvetica, sans-serif",
                    lineHeight: 1,
                }}>
                    <style>
                        {`
                        * {
                            font-family: "Helvetica", sans-serif;
                            line-height: 1;
                        },
                        .export-mode .grid,
                        .export-mode .react-resizable-handle,
                        .export-mode .drag-handle,
                        .export-mode .editor-only {
                            display: none !important;
                        }

                        .export-mode * {
                            outline: none !important;
                        }

                        .image-wrapper {
                            position: relative; /* obrigatório */
                            display: inline-block;
                        }

                        .react-resizable-handle {
                            position: absolute;
                            width: 14px;
                            height: 14px;
                            bottom: 3px;
                            right: 3px;
                            background: #fff;
                            border-radius: 50%; /* formato de LED */
                            cursor: se-resize;
                            z-index: 10000 !important;
                            pointer-events: all !important;

                            /* 💡 Efeito de brilho */
                            box-shadow:
                                0 0 6px rgba(255, 255, 255, 0.9),
                                0 0 10px rgba(0, 150, 255, 0.8),
                                0 0 18px rgba(0, 150, 255, 0.6);

                            /* ✨ Animação de glow pulsante */
                            animation: ledPulse 1.2s infinite ease-in-out;
                        }

                        @keyframes ledPulse {
                            0% {
                                transform: scale(1);
                                box-shadow:
                                    0 0 6px rgba(255,255,255,0.9),
                                    0 0 10px rgba(0,150,255,0.8),
                                    0 0 18px rgba(0,150,255,0.4);
                            }
                            50% {
                                transform: scale(1.15);
                                box-shadow:
                                    0 0 10px rgba(255,255,255,1),
                                    0 0 18px rgba(0,150,255,1),
                                    0 0 30px rgba(0,150,255,0.9);
                            }
                            100% {
                                transform: scale(1);
                                box-shadow:
                                    0 0 6px rgba(255,255,255,0.9),
                                    0 0 10px rgba(0,150,255,0.8),
                                    0 0 18px rgba(0,150,255,0.4);
                            }
                        }
                    `}
                    </style>

                    <div className="container-fluid mt-4">
                        {/* <h3 className="mb-3 text-center">Editor de Tabloide</h3> */}
                        <div className="row">
                            <Modal
                                show={showXlsxModal}
                                onHide={() => setShowXlsxModal(false)}
                                centered
                            >
                                <Modal.Header closeButton>
                                    <Modal.Title>Importar planilha XLSX</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <Form.Group>
                                        <Form.Label>Selecione o arquivo (.xlsx)</Form.Label>
                                        <Form.Control
                                            type="file"
                                            accept=".xlsx"
                                            onChange={(e) => {
                                                if (e.target.files?.length) {
                                                    setXlsxFile(e.target.files[0]);
                                                }
                                            }}
                                        />
                                    </Form.Group>
                                </Modal.Body>

                                <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowXlsxModal(false)}
                                    >
                                        Cancelar
                                    </Button>

                                    <Button
                                        variant="success"
                                        disabled={!xlsxFile || loadingXlsx}
                                        onClick={handleUploadXlsx}
                                    >
                                        {loadingXlsx ? "Enviando..." : "Importar"}
                                    </Button>
                                </Modal.Footer>
                            </Modal>

                            {/* Barra lateral de produtos */}
                            <div className="col-md-3">
                                <Button
                                    onClick={() => props.history.push("/")}
                                >
                                    Voltar ao Menu
                                </Button>
                                <br></br>
                                <br></br>
                                <label>Nome Projeto</label>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    value={projecName || ""}
                                    onChange={(e) => setProjectName(e.target.value)}
                                />
                                <label>Escolha a Capa</label>
                                <select
                                    className="form-control mb-2"
                                    value={selectedCover || ""}
                                    onChange={handleCoverChange}>
                                    <option value="">Selecione a Capa</option>
                                    {cover.map(c => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                                <label>Texto de Capa</label>
                                <input
                                    type="text"
                                    className="form-control mb-2"
                                    value={coverText || ""}
                                    onChange={handleCoverTextChange}
                                />
                                <label>Tamanho da Fonte Capa</label>
                                <br />
                                <input
                                    type="range"
                                    min={20}
                                    max={100}
                                    value={coverFontSize}
                                    onChange={(e) => setCoverFontSize(Number(e.target.value))}
                                />
                                <br />
                                <label>Cor da Fonte</label>
                                <br />
                                <input
                                    type="color"
                                    className="form-control form-control-color mb-2"
                                    value={coverFontColor}
                                    onChange={(e) => setCoverFontColor(e.target.value)}
                                />
                                <br />
                                <label>Escolha o Fundo</label>
                                <select
                                    className="form-control mb-2"
                                    value={selectedBackground || ""}
                                    onChange={handleBackgroundChange}>
                                    <option value="">Selecione o Fundo</option>
                                    {background.map(c => (
                                        <option key={c.id} value={c.id}>
                                            {c.name}
                                        </option>
                                    ))}
                                </select>
                                <label>Escolha o Layout</label>
                                <select
                                    className="form-control mb-2"
                                    value={selectedLayout || ""}
                                    onChange={(e) => handleLayoutChange(e.target.value)}>
                                    <option value="">Selecione Layout</option>
                                    <option value="layout 1 Produto">1 Produto</option>
                                    <option value="layout 2 Produtos">2 Produtos</option>
                                    <option value="layout 4 Produtos">4 Produtos</option>
                                    <option value="layout 6 Produtos">6 Produtos</option>
                                    <option value="layout 8 Produtos">8 Produtos</option>
                                    <option value="layout 12 Produtos">12 Produtos</option>
                                    <option value="layout 20 Produtos">20 Produtos</option>
                                </select>
                                <br></br>
                                <Button variant="primary"
                                    onClick={
                                        addNewPage
                                    }>
                                    Nova Pagina
                                </Button>
                                <br></br> <br></br>
                                <Button variant="success"
                                    onClick={() => setShowXlsxModal(true)}
                                    disabled={
                                        !selectedLayout ||
                                        !slots ||
                                        !slots[selectedLayout]
                                    }
                                >
                                    Importar Produtos Xlsx
                                </Button>
                                &nbsp;&nbsp;&nbsp;&nbsp;
                                <a
                                    href="https://files-rxy.s3.us-east-1.amazonaws.com/exemplo_tabloide.xlsx"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    style={{
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        width: "40px",
                                        height: "40px",
                                        borderRadius: "50%",
                                        backgroundColor: "#d6caca",
                                        color: "#2c17f0",
                                        fontSize: "22px",
                                        fontWeight: "bold",
                                        textDecoration: "none",
                                        cursor: "pointer",
                                        transition: "0.3s"
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = "#e3e8ee"}

                                >
                                    ?
                                </a>
                                <br></br>
                                <br></br>
                                <div
                                    style={{
                                        background: "#f8f9fa",
                                        border: "1px solid #ccc",
                                        borderRadius: "8px",
                                        padding: "10px",
                                        height: "500px",
                                        overflowY: "auto"
                                    }}
                                >
                                    <div style={{ maxWidth: 300, margin: "0 auto" }}>
                                        <h5 className="text-center mb-3">Produtos</h5>

                                        <Select
                                            options={products}
                                            value={selectedProducts}
                                            onChange={handleSelectChange}
                                            placeholder="Selecione um ou mais produtos"
                                            isMulti
                                            isSearchable />

                                        <div className="text-center mt-3">
                                            <button
                                                className="btn btn-primary"
                                                onClick={handleAddSelected}
                                                disabled={selectedProducts.length === 0}
                                            >
                                                Adicionar ao tabloide
                                            </button>
                                        </div>

                                        {/* Pré-visualização dos produtos selecionados */}
                                        {selectedProducts.length > 0 && (
                                            <div className="mt-3">
                                                {selectedProducts.map((p) => (
                                                    <div
                                                        key={p.value}
                                                        className="text-center mb-3 p-2"
                                                        style={{
                                                            background: "#fff",
                                                            borderRadius: "8px",
                                                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                                        }}
                                                    >
                                                        {p.code && (
                                                            <img
                                                                src={`https://raiox-produtos.s3-sa-east-1.amazonaws.com/${p.code}_face.png`}
                                                                alt={p.label}
                                                                width="200"
                                                                draggable={false} />
                                                        )}
                                                        <div>{p.label}</div>
                                                        <strong>R$ {Number(p.price).toFixed(2)}</strong>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                    {activeProduct && (
                                        <div
                                            style={{
                                                position: "fixed",
                                                right: 20,
                                                top: 100,
                                                width: 250,
                                                padding: 15,
                                                background: "#fff",
                                                border: "1px solid #ccc",
                                                borderRadius: 10,
                                                boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                                                zIndex: 99999
                                            }}
                                        >
                                            <h5 style={{ marginBottom: 10 }}>Editar Produto</h5>
                                            <label>Preço:</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                value={activeProduct.price}
                                                onChange={(e) => {
                                                    const result = formatCurrency(e.target.value);

                                                    setPlaced(prev =>
                                                        prev.map(item =>
                                                            item.key === activeProduct.key
                                                                ? { ...item, price: result }
                                                                : item
                                                        )
                                                    );

                                                    setActiveProduct(prev => ({
                                                        ...prev,
                                                        price: result,
                                                    }));
                                                }}
                                            />
                                            <label>Parcelas:</label>
                                            <select
                                                className="form-control mb-2"
                                                value={activeProduct.parcelas || 12}
                                                onChange={(e) => {
                                                    const qtd = Number(e.target.value);
                                                    const result = formatCurrencyAndInstallments(activeProduct.price, qtd);

                                                    // Atualiza no tabloide
                                                    setPlaced(prev => prev.map(item => item.value === activeProduct.value
                                                        ? {
                                                            ...item,
                                                            price: result.formatado,
                                                            parcelas: qtd,
                                                            installments: result.textoParcelas,
                                                            installmentValue: result.valorParcela
                                                        }
                                                        : item
                                                    )
                                                    );

                                                    // Atualiza no painel lateral
                                                    setActiveProduct(prev => ({
                                                        ...prev,
                                                        parcelas: qtd,
                                                        installments: result.textoParcelas,
                                                        installmentValue: result.valorParcela
                                                    }));
                                                }}
                                            >
                                                {Array.from({ length: 24 }, (_, i) => i + 1).map(n => (
                                                    <option key={n} value={n}>
                                                        {n}x
                                                    </option>
                                                ))}
                                            </select>

                                            <label>Valor da Parcela:</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                value={activeProduct.installmentValue}
                                                onChange={(e) => {
                                                    const v = formatCurrency(e.target.value); // R$ 65,00
                                                    const parcelas = activeProduct.parcelas || 1;

                                                    const totalNumero = parcelas * currencyToNumber(v);
                                                    const totalFormatado = totalNumero.toLocaleString("pt-BR", {
                                                        style: "currency",
                                                        currency: "BRL",
                                                    });

                                                    const textoParcelas = `${parcelas}x de ${v}`;

                                                    setPlaced(prev =>
                                                        prev.map(item =>
                                                            item.key === activeProduct.key
                                                                ? {
                                                                    ...item,
                                                                    installmentValue: v,
                                                                    installments: textoParcelas,
                                                                    totalAPrazo: totalFormatado
                                                                }
                                                                : item
                                                        )
                                                    );

                                                    setActiveProduct(prev => ({
                                                        ...prev,
                                                        installmentValue: v,
                                                        installments: textoParcelas,
                                                        totalAPrazo: totalFormatado
                                                    }));
                                                }}
                                            />

                                            <label>Total a Prazo:</label>
                                            <input
                                                type="text"
                                                className="form-control mb-2"
                                                value={activeProduct.totalAPrazo || "R$ 0,00"}
                                                readOnly
                                            />
                                            <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
                                                <label style={{ fontSize: "15px", }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={activeProduct.noInterest}
                                                        onChange={() => toggleFlag("noInterest")}
                                                    /> Sem Juros
                                                </label>
                                                <label style={{ fontSize: "15px", }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={activeProduct.noDownPayment}
                                                        onChange={() => toggleFlag("noDownPayment")}
                                                    /> Sem Entrada
                                                </label>
                                                <label style={{ fontSize: "15px", }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={activeProduct.onTicket}
                                                        onChange={() => toggleFlag("onTicket")}
                                                    /> No Carnê
                                                </label>
                                                <label style={{ fontSize: "15px", }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={activeProduct.onCard}
                                                        onChange={() => toggleFlag("onCard")}
                                                    /> No Cartão
                                                </label>
                                                {/* <label style={{ fontSize: "15px", }}>
                                                    <input
                                                        type="checkbox"
                                                        checked={activeProduct.highlightedPlots}
                                                        onChange={() => toggleFlag("highlightedPlots")}
                                                    /> Parcelas em Destaque
                                                </label> */}
                                            </div>
                                            <button
                                                className="btn btn-secondary btn-sm mt-2"
                                                onClick={() => setActiveProduct(null)}
                                            >
                                                Fechar
                                            </button>
                                            &nbsp;&nbsp;
                                            <button
                                                className="btn btn-danger btn-sm mt-2"
                                                disabled={!activeProduct}
                                                onClick={() => handleRemove(activeProduct)}
                                            >
                                                Remover
                                            </button>
                                        </div>
                                    )}
                                </div>
                                {/* <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                                    <label style={{ fontSize: "15px" }}>
                                        <input
                                            type="checkbox"
                                            checked={noInterest}
                                            onChange={(e) => {
                                                const value = e.target.checked;
                                                setNoInterest(value);
                                                applyFlagToAllPages("noInterest", value);
                                            }}
                                        />{" "}
                                        Sem Juros
                                    </label>

                                    <label style={{ fontSize: "15px" }}>
                                        <input
                                            type="checkbox"
                                            checked={noDownPayment}
                                            onChange={(e) => {
                                                const value = e.target.checked;
                                                setNoDownPayment(value);
                                                applyFlagToAllPages("noDownPayment", value);
                                            }}
                                        />{" "}
                                        Sem Entrada
                                    </label>

                                    <label style={{ fontSize: "15px" }}>
                                        <input
                                            type="checkbox"
                                            checked={onTicket}
                                            onChange={(e) => {
                                                const value = e.target.checked;
                                                setOnTicket(value);
                                                applyFlagToAllPages("onTicket", value);
                                            }}
                                        />{" "}
                                        No Carnê
                                    </label>

                                    <label style={{ fontSize: "15px" }}>
                                        <input
                                            type="checkbox"
                                            checked={onCard}
                                            onChange={(e) => {
                                                const value = e.target.checked;
                                                setOnCard(value);
                                                applyFlagToAllPages("onCard", value);
                                            }}
                                        />{" "}
                                        No Cartão
                                    </label>
                                </div> */}
                                <div className="text-center mt-3" style={{ alignItems: "center", width: "150px" }}>
                                    <label>Validade: </label>
                                    <input
                                        className="form-control mb-4"
                                        type="date"
                                        value={validate}
                                        onChange={(e) => setValidade(e.target.value)} />
                                </div>
                                <div className="d-flex align-items-center gap-2 mt-2">
                                    <button
                                        className="btn btn-secondary"
                                        disabled={activePage === 0}
                                        onClick={() => setActivePage(p => Math.max(0, p - 1))}
                                    >
                                        ◀ Página anterior
                                    </button>

                                    <span>
                                        Página {activePage + 1} de {pages.length}
                                    </span>

                                    <button
                                        className="btn btn-secondary"
                                        disabled={activePage === pages.length - 1}
                                        onClick={() => setActivePage(p => Math.min(pages.length - 1, p + 1))}
                                    >
                                        Próxima página ▶
                                    </button>
                                </div>
                                {/* <br></br>
                                <Button variant="primary"
                                    onClick={
                                        addNewPage
                                    }>
                                    Nova Pagina
                                </Button> */}
                                <div className="text-center mt-3">
                                    {project?.data?.id ? (
                                        <Button variant="warning" onClick={handleSave}>
                                            Editar Tabloide
                                        </Button>
                                    ) : (
                                        <Button variant="primary" onClick={handleSave}>
                                            Salvar Tabloide
                                        </Button>
                                    )}
                                    &nbsp; &nbsp;
                                    {/* <Button variant="success" color="success" onClick={handleGenerate}>
                                        Gerar
                                    </Button> */}
                                    <Button variant="success" color="success" onClick={handleGeneratePupper}>
                                        Gerar Tabloide
                                    </Button>

                                    &nbsp; &nbsp;
                                    <Button variant="warning" style={{ color: "white" }} onClick={handlePreviewPage}>
                                        Preview Página
                                    </Button>
                                </div>
                                <br />
                            </div>
                            {/* Área do tabloide */}

                            <div className="col-md-9" style={{ position: 'relative', minHeight: '1920px' }}>
                                <div
                                    ref={tabloidRef}
                                    className={exportMode ? "export-mode" : ""}
                                    id="tabloid"
                                    style={{
                                        position: "relative",
                                        width: "1080px",
                                        height: "1920px",
                                        top: 0,
                                        // left:0,
                                        // ADICIONE ESTAS LINHAS ABAIXO:
                                        minWidth: "1080px",
                                        minHeight: "1920px",
                                        boxSizing: "border-box",
                                        display: "block",
                                        WebkitPrintColorAdjust: "exact",
                                        printColorAdjust: "exact",
                                        margin: "0",
                                        padding: "0",
                                        // backgroundImage: `url(${pages[activePage].background})`,
                                        backgroundImage:
                                            activePage === 0 && coverBackground
                                                ? `url(${coverBackground})`
                                                : `url(${pages[activePage]?.background})`,
                                        backgroundSize: "100% 100%",
                                        overflow: "hidden",
                                        boxSizing: "border-box",
                                        display: "block",
                                        unicodeBidi: "isolate",
                                        lineHeight: 0,        // Remove espaços extras de fontes
                                        fontSize: 0,          // Remove espaços vazios entre divs inline-block
                                        textAlign: "left",
                                        transform: "translateZ(0)"
                                    }}
                                >
                                    {activePage === 0 && showCoverText && (
                                        <Draggable
                                            position={{ x: coverBox.x, y: coverBox.y }}
                                            onStop={(e, data) => {
                                                setCoverBox({
                                                    x: data.x,
                                                    y: data.y,
                                                });
                                            }}>
                                            <div
                                                style={{
                                                    width: 600,
                                                    height: 200,
                                                    background: "rgba(0,0,0,0.6)",
                                                    color: coverFontColor,
                                                    fontFamily: 'FontName',
                                                    fontSize: `${coverFontSize}px`,
                                                    fontWeight: "bold",
                                                    textAlign: "start",
                                                    whiteSpace: "pre-wrap",
                                                    zIndex: 9999,
                                                    cursor: "move",
                                                }}
                                            >
                                                {coverText || "Digite o texto da capa"}
                                            </div>
                                        </Draggable>
                                    )}
                                    {horizontalLines}
                                    {verticalLines}
                                    { activePage !== 0 && placed && placed.map((p, i) => (
                                        // <React.Fragment>
                                        <div key={`${p.value}-${i}`} style={{
                                            position: "absolute",
                                            left: 0,
                                            width: "100%",
                                            height: "100%"
                                        }}>
                                            {/* ================= PARCELAS (12x) ================= */}
                                            <Draggable
                                                position={{ x: p.parcelasX ?? 0, y: p.parcelasY ?? 0 }}
                                                onStop={(_e, data) => handleDrag(i, "parcelas", data)}
                                                cancel=".react-resizable-handle"
                                            >
                                                <ResizableBox
                                                    width={p.parcelasW || 80}
                                                    height={p.parcelasH || 40}
                                                    minConstraints={[40, 20]}
                                                    maxConstraints={[300, 150]}
                                                    resizeHandles={["se"]}
                                                    onResizeStop={(e, data) => {
                                                        setPlaced(prev => prev.map(item => item.value === p.value
                                                            ? {
                                                                ...item,
                                                                parcelasW: data.size.width,
                                                                parcelasH: data.size.height
                                                            }
                                                            : item
                                                        ));
                                                    }}
                                                >
                                                    {/* Container Flex Vertical para alinhar tudo um embaixo do outro */}
                                                    <div style={{
                                                        display: "flex",
                                                        flexDirection: "column", // Alinha em coluna
                                                        alignItems: "flex-start", // Alinha à esquerda
                                                        width: "100%",
                                                        height: "100%",
                                                        lineHeight: 1 // Remove espaçamentos extras de linha
                                                    }}>

                                                        {/* Div das Parcelas - Removi a altura fixa de 100px */}
                                                        <div
                                                            style={{
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "flex-start",
                                                                background: "transparent",
                                                                color: "#fff",
                                                                fontWeight: "bold",
                                                                fontSize: fontSizeInstallment(),
                                                                fontFamily: 'fontName',
                                                                userSelect: "none",
                                                                marginBottom: "2px" // Pequeno espaço antes das tags
                                                            }}
                                                        >
                                                            {p.parcelas}x
                                                        </div>

                                                        {/* Tags de Condições */}
                                                        <div style={{ display: "flex", flexDirection: "column", gap: "1px", width: '200px' }}>
                                                            {p.noInterest && (
                                                                <p style={{ fontSize: fontSizePaymentTags(), fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                                    Sem Juros
                                                                </p>
                                                            )}
                                                            {p.noDownPayment && (
                                                                <p style={{ fontSize: fontSizePaymentTags(), fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                                    Sem Entrada
                                                                </p>
                                                            )}
                                                            {p.onCard && (
                                                                <p style={{ fontSize: fontSizePaymentTags(), fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                                    No Cartão
                                                                </p>
                                                            )}
                                                            {p.onTicket && (
                                                                <p style={{ fontSize: fontSizePaymentTags(), fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                                    No Carnê
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                </ResizableBox>
                                            </Draggable>
                                            {/* <Draggable
                                                position={{ x: p.parcelasX ?? 0, y: p.parcelasY ?? 0 }}
                                                onStop={(_e, data) => handleDrag(i, "parcelas", data)}
                                                cancel=".react-resizable-handle"
                                            >
                                                <ResizableBox
                                                    width={p.parcelasW || 80}
                                                    height={p.parcelasH || 40}
                                                    minConstraints={[40, 20]}
                                                    maxConstraints={[300, 150]}
                                                    resizeHandles={["se"]}
                                                    onResizeStop={(e, data) => {

                                                        setPlaced(prev => prev.map(item => item.value === p.value
                                                            ? {
                                                                ...item,
                                                                parcelasW: data.size.width,
                                                                parcelasH: data.size.height
                                                            }
                                                            : item
                                                        )
                                                        );
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            width: "100px",
                                                            height: "100px",
                                                            display: "flex",
                                                            alignItems: "start",
                                                            justifyContent: "initial",
                                                            background: "transparent",
                                                            color: "#fff",
                                                            fontWeight: "bold",
                                                            fontSize: fontSizeInstallment(),
                                                            fontFamily: 'fontName',
                                                            userSelect: "none"
                                                        }}
                                                    >
                                                        {p.parcelas}x
                                                    </div>

                                                    <p style={{ fontSize: "12px", fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                        {p.noInterest ? "Sem Juros" : ""}
                                                    </p>
                                                    <p style={{ fontSize: "12px", fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                        {p.noDownPayment ? "Sem Entrada" : ""}
                                                    </p>
                                                    <p style={{ fontSize: "12px", fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                        {p.onCard ? "No Cartão" : ""}
                                                    </p>
                                                    <p style={{ fontSize: "12px", fontFamily: "fontCarac", color: "#fff", fontWeight: "bolder", margin: 0 }}>
                                                        {p.onTicket ? "No Carnê" : ""}
                                                    </p>
                                                </ResizableBox>
                                            </Draggable> */}
                                            {/* ================= NOME DO PRODUTO ================= */}
                                            <Draggable
                                                position={{ x: p.nameX ?? 0, y: p.nameY ?? 0 }}
                                                onStop={(e, data) => handleDrag(i, "name", data)}
                                            >

                                                <div
                                                    style={{
                                                        fontSize: fontSizeProductName(),
                                                        fontWeight: "bold",
                                                        color: "#fff",
                                                        fontFamily: 'fontName',
                                                        height: "auto",
                                                        position: "absolute",
                                                        top: 0,  // <--- ADICIONE ISSO
                                                        left: 0, // <--- ADICIONE ISSO
                                                        lineHeight: "normal",
                                                        zIndex: 10,
                                                        cursor: "move",
                                                    }}
                                                >
                                                    {p.name}
                                                </div>
                                            </Draggable>

                                            {/* ================= CARACTERÍSTICAS ================= */}
                                            <Draggable
                                                position={{ x: p.caracX ?? 0, y: p.caracY ?? 0 }}
                                                onDrag={(e, data) => {
                                                    if (selectedProductId === p.value) {
                                                        moveWholeProduct(i, data.deltaX, data.deltaY);
                                                    }
                                                }}
                                                onStop={(e, data) => handleDrag(i, "carac", data)}
                                            >
                                                <div style={{
                                                    fontSize: fontSizeProductCarac(),
                                                    color: "#fff",
                                                    fontFamily: "fontCarac",
                                                    height: "auto",
                                                    position: "absolute",
                                                    top: 0,  // <--- ADICIONE ISSO
                                                    left: 0, // <--- ADICIONE ISSO
                                                    lineHeight: "normal",
                                                    zIndex: 10,
                                                    cursor: "move",
                                                }}>
                                                    {p.carac_1}<br />
                                                    {p.carac_2}<br />
                                                    {p.carac_3}<br />
                                                    {p.carac_4}
                                                </div>
                                            </Draggable>

                                            {/* ================== CLICK VIDEO ============*/}
                                            {p.videoLink && (
                                                <Draggable
                                                    position={{ x: p.caracX ?? 0, y: p.caracY ?? 0 }}
                                                    onDrag={(e, data) => {
                                                        if (selectedProductId === p.value) {
                                                            moveWholeProduct(i, data.deltaX, data.deltaY);
                                                        }
                                                    }}
                                                    onStop={(e, data) => handleDrag(i, "carac", data)}
                                                >
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/click_video.png`}
                                                        alt={p.label}
                                                        draggable={false}
                                                        style={{ width: clickVideoSize(), height: "auto", marginTop: '5px' }}
                                                    />
                                                </Draggable>
                                            )}

                                            {/* ================= IMAGEM ================= */}
                                            <Draggable
                                                position={{ x: p.imageX ?? 0, y: p.imageY ?? 0 }}
                                                onStart={(e) => {
                                                    if (isGroupDrag(e)) {
                                                        setSelectedProductId(p.value);
                                                    } else {
                                                        setSelectedProductId(null);
                                                    }
                                                }}
                                                onDrag={(e, data) => {
                                                    if (isGroupDrag(e)) {
                                                        moveWholeProduct(i, data.deltaX, data.deltaY);
                                                    } else {
                                                        setPlaced(prev =>
                                                            prev.map((item, idx) =>
                                                                idx === i
                                                                    ? {
                                                                        ...item,
                                                                        imageX: data.x,
                                                                        imageY: data.y
                                                                    }
                                                                    : item
                                                            )
                                                        );
                                                    }
                                                }}
                                                cancel=".react-resizable-handle"
                                            >
                                                {/* ESTA DIV É O SEGREDO */}
                                                <div style={{
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    width: p.imageW,  // 🔥 Define a largura exata da imagem
                                                    height: p.imageH, // 🔥 Define a altura exata da imagem
                                                    zIndex: 10 + i,   // 💡 Garante que cada uma tenha um nível diferente
                                                    cursor: "move",
                                                }}>
                                                    <ResizableBox
                                                        width={p.imageW}
                                                        height={p.imageH}
                                                        // ... restante do ResizableBox
                                                        style={{
                                                            outline: selectedProductId === p.value
                                                                ? "2px dashed rgba(0,123,255,0.8)"
                                                                : "none",
                                                        }}
                                                    >
                                                        <img
                                                            src={`https://raiox-produtos.s3-sa-east-1.amazonaws.com/${p.code}_face.png`}
                                                            alt={p.label}
                                                            draggable={false}
                                                            style={{
                                                                width: "100%",
                                                                height: "100%",
                                                                objectFit: "contain",
                                                                pointerEvents: "none", // Isso permite clicar "através" da imagem para o drag funcionar
                                                                display: "block"
                                                            }}
                                                        />
                                                    </ResizableBox>
                                                </div>
                                            </Draggable>

                                            {/* ================= PREÇO ================= */}
                                            <Draggable
                                                position={{ x: p.priceX ?? 0, y: p.priceY ?? 0 }}
                                                onStop={(e, data) => handleDrag(i, "price", data)}
                                            >
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setActiveProduct(p);
                                                    }}
                                                    style={{
                                                        width: "200px",
                                                        position: "absolute", // 🔥 Mova para cá
                                                        top: 0,               // 🔥 Mova para cá
                                                        left: 0,              // 🔥 Mova para cá
                                                        zIndex: 10,
                                                        cursor: "move",
                                                        lineHeight: "0"       // 🔥 Evita que a div tenha altura fantasma
                                                    }}
                                                >
                                                    <strong
                                                        style={{
                                                            fontSize: fontSizeProductPrice(),
                                                            color: "#d7ec13",
                                                            fontFamily: "fontPrice",
                                                            height: "auto",
                                                            display: "block",     // 🔥 Garante que se comporte como bloco
                                                            lineHeight: "normal",
                                                            whiteSpace: "nowrap"  // 🔥 Impede o preço de quebrar linha
                                                        }}
                                                    >
                                                        {p.price}
                                                    </strong>
                                                </div>
                                            </Draggable>
                                            {/* <Draggable
                                                position={{ x: p.priceX ?? 0, y: p.priceY ?? 0 }}
                                                onStop={(e, data) => handleDrag(i, "price", data)}
                                            >
                                                <div
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        setActiveProduct(p);
                                                    }}
                                                    style={{ width: "200px" }}
                                                >
                                                    <strong
                                                        style={{
                                                            fontSize: fontSizeProductPrice(),
                                                            color: "#d7ec13",
                                                            fontFamily: "fontPrice",
                                                            height: "auto",
                                                            position: "absolute",
                                                            top: 0,  // <--- ADICIONE ISSO
                                                            left: 0, // <--- ADICIONE ISSO
                                                            lineHeight: "normal",
                                                            zIndex: 10,
                                                            cursor: "move",
                                                        }}
                                                    >
                                                        {p.price}
                                                    </strong>
                                                </div>
                                            </Draggable> */}

                                            {/* ================= TEXTO DAS PARCELAS (ex: "12x de R$ 50,00") ================= */}
                                            <Draggable
                                                position={{
                                                    x: p.installmentsX ?? 0,
                                                    y: p.installmentsY ?? 0
                                                }}
                                                onStop={(e, data) => {
                                                    setPlaced(prev => prev.map(item => item.value === p.value
                                                        ? {
                                                            ...item,
                                                            installmentsX: data.x,
                                                            installmentsY: data.y
                                                        }
                                                        : item
                                                    ));
                                                }}
                                            >
                                                {/* O ESTILO DEVE FICAR NESTA DIV ABAIXO */}
                                                <div style={{
                                                    width: "200px",
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 10,
                                                    cursor: "move",
                                                    lineHeight: "0",
                                                    // Estilos do texto transportados para cá ou mantidos no filho
                                                }}>
                                                    <div style={{
                                                        fontSize: fontSizeInstallmentText(),
                                                        color: "#fff",
                                                        height: "auto",
                                                        display: "block",
                                                        lineHeight: "normal",
                                                        whiteSpace: "nowrap"
                                                    }}>
                                                        {p.installments}
                                                    </div>
                                                </div>
                                            </Draggable>
                                            {/* ================= TEXTO DAS TOTAL A PRAZO (ex: "12x de R$ 50,00") ================= */}
                                            <Draggable
                                                position={{
                                                    x: p.totalTermX ?? 0,
                                                    y: p.totalTermY ?? 0
                                                }}
                                                onStop={(e, data) => {
                                                    setPlaced(prev => prev.map(item => item.value === p.value
                                                        ? {
                                                            ...item,
                                                            totalTermX: data.x,
                                                            totalTermY: data.y
                                                        }
                                                        : item
                                                    )
                                                    );
                                                }}
                                            >
                                                <div style={{
                                                    width: "200px",
                                                    position: "absolute",
                                                    top: 0,
                                                    left: 0,
                                                    zIndex: 10,
                                                    cursor: "move",
                                                    lineHeight: "0",
                                                    // Estilos do texto transportados para cá ou mantidos no filho
                                                }}>
                                                    <div style={{
                                                        fontSize: fontSizeTotalTerm(),
                                                        color: "#fff",
                                                        height: "auto",
                                                        display: "block",
                                                        lineHeight: "normal",
                                                        whiteSpace: "nowrap"
                                                    }}>
                                                        Total à Prazo {p.totalAPrazo}
                                                    </div>
                                                </div>
                                            </Draggable>
                                        </div>
                                        // </React.Fragment>

                                    ))}
                                    <div style={{
                                        position: "absolute",
                                        bottom: "1px",          // Agora positivo, subindo 20px da borda inferior real
                                        left: 0,
                                        width: "100%",
                                        textAlign: "center",
                                        lineHeight: "normal",    // Importante: Reseta o 0 do pai para o texto aparecer
                                        pointerEvents: "none"    // Garante que o texto não bloqueie cliques em produtos próximos
                                    }}>
                                        <p style={{
                                            color: "#fff",
                                            fontSize: "20px",
                                            margin: 0,           // Remove a margem padrão que causava o deslocamento
                                            fontWeight: "bold",
                                            textShadow: "1px 1px 2px rgba(0,0,0,0.8)" // Opcional: ajuda a ler sobre qualquer fundo
                                        }}>
                                            Ofertas Válidas Até: {formatDate(validate)}
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

            </>
        </LoadingOverlay >

    );
}
export default withRouter(TabloidEditor)